<div class="prm__backdrop" aria-hidden="true" (click)="close()"></div>

<section
  #dialog
  class="prm"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="titleId"
  tabindex="-1"
>
  <header class="prm__header">
    <h2 class="prm__title" [id]="titleId">{{ copy.modalTitle(card().alias) }}</h2>
    <button type="button" class="prm__close" [attr.aria-label]="copy.closeLabel" (click)="close()">×</button>
  </header>

  @switch (sender()) {
    @case ('need-profile') {
      <!-- Sin perfil con consentimiento la API respondería NEED_PROFILE: se ahorra el 422. -->
      <div class="prm__gate">
        <p class="prm__gate-text">{{ copy.needProfileFallback }}</p>
        <a class="prm__primary" [routerLink]="profilePath" (click)="close()">{{ copy.needProfileCta }}</a>
      </div>
    }
    @case ('suspended') {
      <div class="prm__gate">
        <p class="prm__gate-text">
          {{ suspendedCopy.suspendedBefore }}<a routerLink="/contacto" (click)="close()">{{ suspendedCopy.suspendedLink }}</a>{{ suspendedCopy.suspendedAfter }}
        </p>
      </div>
    }
    @default {
      <form class="prm__form" [formGroup]="form" (ngSubmit)="submit()" novalidate>
        <div class="prm__field">
          <label class="prm__label" for="prm-game">{{ copy.gameLabel }}</label>
          <select id="prm-game" class="prm__input" formControlName="game">
            <option value="">{{ copy.noGame }}</option>
            @for (game of card().games; track game.slug) {
              <option [value]="game.slug">{{ game.name }}</option>
            }
          </select>
          @if (fieldErrors().game; as error) {
            <p class="prm__error" data-field="game">{{ error }}</p>
          }
        </div>

        <div class="prm__field">
          <label class="prm__label" for="prm-message">{{ copy.messageLabel }}</label>
          <textarea
            id="prm-message"
            class="prm__input prm__textarea"
            formControlName="message"
            rows="3"
            [attr.maxlength]="messageMax"
            aria-describedby="prm-message-help"
            (input)="onMessageInput()"
          ></textarea>
          <div class="prm__help-row">
            <p class="prm__help" id="prm-message-help">{{ copy.messageHelp }}</p>
            <span class="prm__counter" aria-live="polite">{{ copy.messageCounter(messageLength(), messageMax) }}</span>
          </div>
          @if (fieldErrors().message; as error) {
            <p class="prm__error" data-field="message">{{ error }}</p>
          }
        </div>

        <!-- Honeypot (patrón W3 del newsletter): fuera de pantalla, nunca display:none, sin `name`. -->
        <div class="prm__hp" aria-hidden="true">
          <input type="text" formControlName="website" tabindex="-1" autocomplete="off" />
        </div>

        @if (generalError(); as error) {
          <div class="prm__alert" role="alert">
            <p class="prm__alert-text">{{ error.text }}</p>
            @if (error.profileCta) {
              <a [routerLink]="profilePath" (click)="close()">{{ copy.needProfileCta }}</a>
            }
          </div>
        }

        <div class="prm__actions">
          <button type="submit" class="prm__primary" [disabled]="!canSubmit()">{{ copy.send }}</button>
          <button type="button" class="prm__secondary" (click)="close()">{{ copy.cancel }}</button>
        </div>

        <p class="prm__notice">
          {{ copy.noticeBefore }}<a [href]="privacyPath + '#' + privacyFragment" target="_blank" rel="noopener">{{ copy.noticeLink }}</a>
        </p>
      </form>
    }
  }
</section>
